import {AfterViewInit, Component, Directive, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';
import {BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';
import {environment} from '../../../../../environments/environment';
import {FormBuilder} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {language} from '../../../../language/vn';
import {ToTrinhXuLyService} from '../../../../service/totrinh/service-totrinhxuly';
import {ToTrinhFileNXLService} from '../../../../service/totrinh/service-totrinhfilenxl';

import {ToTrinhXuLy} from '../../../../models/totrinh/totrinhxuly';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {ChenHoSoToTrinhNhanComponent} from '../chenhoso/chenhosotcn.component';
import {CTToTrinhNhanComponent} from '../chuyentrinh/chuyentrinhtcn.component';
import {XuLyTongHopToTrinhComponent} from '../xuly/xuly.component';
import {GVToTrinhComponent} from '../chuyengiaoviec/giaoviec.component';
import {DatePipe} from '@angular/common';
import {FormatService} from '../../../../service/format/service-format';
import {XuLyDetailToTrinhComponent} from '../xuly/detailtotrinh.component';
import {TongHopYKienToTrinhComponent} from '../xuly/tonghop.component';
import {CommandUtil} from '../../../../global/commandutil';
import {NavItemService} from '../../../../service/staff/service-navitem';
import {RolePermissionService} from '../../../../service/security/service-rolepermission';
import {LogViewItemEgovComponent} from '../../log/logviewitem.component';
@Component({
  templateUrl: './totrinhnhan.component.html',

})
export class ToTrinhNhanComponent implements OnInit, AfterViewInit {
  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  @ViewChild(XuLyDetailToTrinhComponent)
  public xuLyToTrinhDetail: XuLyDetailToTrinhComponent;
  private moduleName: string = 'egov.info.totrinh.nhan';
  public language = language;
  public totalItemsReal: number =0;
  public totalItems: number = 0;
  public hoSoId:  number;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public configToolbar: Object = environment.configToolbar;
  public dataList: ToTrinhXuLy[];
  public srChuDe: string = '';
  public uploadUrl: String;
  public deleteUrl: String;
  public fileLists: Object[];
  public srStatus: string = '';
  public totalChuaXuLy: number = 0;
  public totalDangXuLy: number = 0;
  public totalHoanThanh: number =0;
  public totalChuaXem: number=0;
  public totalDaXem: number=1;
  public totalChuaXemYKien: number=2;
  public totalDaXemYKien: number=3;
  public staffId: number = Sessioncommand.staffId;
  public sChuaXuLy: number= environment.chuaxuly;
  public sDangXuLy: number= environment.dangxuly;
  public sHoanThanh: number= environment.hoanthanh;
  public status: number[] =[   environment.chuaxuly,
    environment.dangxuly,
    environment.hoanthanh
  ];
  public srFromDate: Date ;
  public srToDate: Date;
  public strF: string= '';
  public strT: string= '';
  public xem: number = -1;
  public showDetails: boolean = false;
  public toTrinhId: number = 0;
  public nextId: number = 0;
  public trangThaiHoanThanh: number = environment.hoanthanh;
  public dateCurrent: Date = new Date();
  private permissionView: boolean = false;
  private permissionChenHoSo: boolean = false;
  private permissionChuyenTrinh: boolean = false;
  private permissionXuLy: boolean = false;
  private permissionChuyenGiaoViec: boolean = false;
  private permissionYKienTongHop: boolean = false;
  private permissionDownload: boolean = false;
  constructor(
    private toTrinhXuLyService: ToTrinhXuLyService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private bsModalService: BsModalService,
    private commandUtil: CommandUtil,
    private toTrinhFileNXLService: ToTrinhFileNXLService,
    private datePipe: DatePipe,
    private formatService: FormatService,
    private navItemService: NavItemService,
    private rolePermissionService: RolePermissionService
  ) {
  }
  ngAfterViewInit() {

  }
  public chenHoSo(id: number) {
    const modalEdit = this.bsModalService.show(ChenHoSoToTrinhNhanComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<ChenHoSoToTrinhNhanComponent>modalEdit.content).edit(
      id
    );
    (<ChenHoSoToTrinhNhanComponent>modalEdit.content).onClose.subscribe(result => {

    });
  }
  public xuLy(id: number) {
    if(this.permissionXuLy)
    {
      const modalEdit = this.bsModalService.show(XuLyTongHopToTrinhComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
      (<XuLyTongHopToTrinhComponent>modalEdit.content).edit(
        id, true
      );
      (<XuLyTongHopToTrinhComponent>modalEdit.content).onClose.subscribe(result => {

      });
    }
  }
  public chuyenTrinh(id: number) {
    const modalEdit = this.bsModalService.show(CTToTrinhNhanComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<CTToTrinhNhanComponent>modalEdit.content).edit(
      id
    );
    (<CTToTrinhNhanComponent>modalEdit.content).onClose.subscribe(result => {

    });

  }
  ngOnInit(): void {
    this.srStatus = this.status.join();
    this.formatService.getCurrentDateVN().subscribe(x => {
      this.dateCurrent = this.commandUtil.getDate(x);
    });
    this.rolePermissionService.checkPermissionByModule(Sessioncommand.staffId, this.moduleName
    ).subscribe( x => {
        this.permissionView = x.findIndex(y => y.action === environment.view) !== -1;
        if (this.permissionView)
          this.search();
        else
          this.rolePermissionService.redirectAccesDenied();
        this.permissionChenHoSo = x.findIndex(y => y.action === environment.chenhoso) !== -1;
        this.permissionChuyenGiaoViec = x.findIndex(y => y.action === environment.chuyengiaoviec) !== -1;
        this.permissionChuyenTrinh = x.findIndex(y => y.action === environment.chuyentrinh) !== -1;
        this.permissionXuLy = x.findIndex(y => y.action === environment.xuly) !== -1;
        this.permissionYKienTongHop = x.findIndex(y => y.action === environment.ykientonghop) !== -1;
        this.permissionDownload = x.findIndex(y => y.action === environment.download) !== -1;
    });
  }
  edit(id: number) {

  }
  public loadTotal()
  {
    this.strF = this.datePipe.transform(this.srFromDate, 'MM/dd/yyyy');
    this.strT =  this.datePipe.transform(this.srToDate, 'MM/dd/yyyy');
    this.toTrinhXuLyService.getCountByKeyword(this.srChuDe, environment.chuaxuly.toString(), this.staffId, -1, this.strF, this.strT ).subscribe(recordCount => this.totalChuaXuLy = recordCount);
    this.toTrinhXuLyService.getCountByKeyword(this.srChuDe, environment.dangxuly.toString(), this.staffId, -1, this.strF, this.strT).subscribe(recordCount => this.totalDangXuLy = recordCount);
    this.toTrinhXuLyService.getCountByKeyword(this.srChuDe, environment.hoanthanh.toString(), this.staffId, -1, this.strF, this.strT).subscribe(recordCount => this.totalHoanThanh = recordCount);
    this.toTrinhXuLyService.getCountByKeyword(this.srChuDe, this.status.join().toString(), this.staffId, 2, this.strF, this.strT).subscribe(recordCount => this.totalChuaXemYKien = recordCount);
    this.toTrinhXuLyService.getCountByKeyword(this.srChuDe, this.status.join().toString(), this.staffId, 3, this.strF, this.strT).subscribe(recordCount => this.totalDaXemYKien = recordCount);
    this.toTrinhXuLyService.getCountByKeyword(this.srChuDe, this.status.join().toString(), this.staffId, -1, this.strF, this.strT).subscribe(recordCount => this.totalItemsReal = recordCount);
  }
  search()
  {
    this.loadTotal();
    this.strF = this.datePipe.transform(this.srFromDate, 'MM/dd/yyyy');
    this.strT =  this.datePipe.transform(this.srToDate, 'MM/dd/yyyy');
    this.toTrinhXuLyService.findAllByPaging(this.srChuDe, this.srStatus, this.staffId, this.xem, this.strF, this.strT, this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.toTrinhXuLyService.getCountByKeyword(this.srChuDe, this.srStatus, this.staffId, this.xem, this.strF, this.strT).subscribe(recordCount => this.totalItems = recordCount);

  }
  public chuyenGiaoViec(id: number) {
    const modalEdit = this.bsModalService.show(GVToTrinhComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<GVToTrinhComponent>modalEdit.content).edit(
      id
    );
    (<GVToTrinhComponent>modalEdit.content).onClose.subscribe(result => {

    });

  }
  public lichSuTruyCap(id: number) {
    const modalEdit = this.bsModalService.show(LogViewItemEgovComponent, {class: 'modal-lg', keyboard: false, backdrop: 'static'});
    (<LogViewItemEgovComponent>modalEdit.content).show(
      id, environment.TOTRINH
    );
    (<LogViewItemEgovComponent>modalEdit.content).onClose.subscribe(result => {

    });
  }
  public nextPage()
  {
    if( this.nextId + 1 >= this.dataList.length)
    {
      if(this.currentPage < this.numPages) {
        this.currentPage = this.currentPage + 1;
        this.toTrinhXuLyService.findAllByPaging(this.srChuDe, this.status.join().toString(), this.staffId, this.xem, this.strF, this.strT, this.currentPage, this.maxSize).subscribe(dataList => {
          this.dataList = dataList;
          if (this.dataList.length > 0)
          {
            this.toTrinhId = this.dataList[0].maYeuCau;
            this.nextId = 0;
            this.xuLyToTrinhDetail.edit(this.toTrinhId);
          }
        });
      }
    }
    else
    {
      this.nextId = this.nextId + 1;
      this.toTrinhId = this.dataList [ this.nextId === this.dataList.length ? this.dataList.length -1 : this.nextId ].maYeuCau;
      this.xuLyToTrinhDetail.edit( this.toTrinhId);
    }
  }
  public backPage()
  {
    if( this.nextId - 1  < 0)
    {
      if(this.currentPage > 1) {
        this.currentPage = this.currentPage - 1;
        this.toTrinhXuLyService.findAllByPaging(this.srChuDe, this.status.join().toString(), this.staffId, this.xem, this.strF, this.strT, this.currentPage, this.maxSize).subscribe(dataList => {
          this.dataList = dataList;
          if (this.dataList.length > 0)
          {
            this.nextId = this.dataList.length - 1;
            this.toTrinhId = this.dataList[this.nextId].maYeuCau;
            this.xuLyToTrinhDetail.edit(this.toTrinhId);

          }
        });
      }
    }
    else
    {
      this.nextId = this.nextId  - 1;
      this.toTrinhId = this.dataList [ this.nextId === -1 ? 0 : this.nextId].maYeuCau;
      this.xuLyToTrinhDetail.edit( this.toTrinhId);
    }
  }
  public yKienTongHop(id: number) {
    const modalEdit = this.bsModalService.show(TongHopYKienToTrinhComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<TongHopYKienToTrinhComponent>modalEdit.content).edit(
      id
    );
    (<TongHopYKienToTrinhComponent>modalEdit.content).onClose.subscribe(result => {
    });

  }
  public detailXuLy(id: number) {
    if (this.permissionXuLy)
    {
      this.toTrinhId = id;
      this.nextId = this.dataList.findIndex( x => x.id === id);
      this.showDetails = true;
    }

  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }

}

